export default __webpack_public_path__ + "static/media/home1.e03f10e7.jpg";